/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_TranslateInputs */

const cs_social_export_caption_translate = /** @type {(inputs: Social_Export_Caption_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeložit`)
};

const en_social_export_caption_translate = /** @type {(inputs: Social_Export_Caption_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate`)
};

/**
* | output |
* | --- |
* | "Translate" |
*
* @param {Social_Export_Caption_TranslateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_translate = /** @type {((inputs?: Social_Export_Caption_TranslateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_TranslateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_translate(inputs)
	return cs_social_export_caption_translate(inputs)
});